import type { Testimonial } from '../types/content';

export const stats = [['+180', 'familias aplicando el sistema*'], ['4', 'Volúmenes completos'], ['5', 'Bonos incluidos'], ['4.9/5', 'calificación ⭐*']];

export const testimonials: Testimonial[] = [{
  name: 'Andrea V.',
  place: 'Buenos Aires',
  quote: 'Ahora puedo abrir el freezer y encontrar rápidamente una comida que ya había preparado. Me cambió muchísimo la forma de organizar la semana.'
}, {
  name: 'Carolina M.',
  place: 'Córdoba',
  quote: 'Lo que más me gustó fue tener una estructura para cocinar por tandas. Antes empezaba sin saber por dónde y terminaba agotada.'
}, {
  name: 'Julieta T.',
  place: 'Rosario',
  quote: 'Con el sistema de planificación dejé de hacer compras sin rumbo. Primero miro qué tengo, armo la semana y recién después preparo la lista.'
}];

export const extendedTestimonials: Testimonial[] = [{
  name: 'Laura P.',
  place: 'Córdoba',
  quote: 'Antes llegaba todos los días a la cena sin tener idea de qué preparar. Ahora tengo varias cosas listas y sé exactamente qué puedo usar.'
}, {
  name: 'Mariana G.',
  place: 'Rosario',
  quote: 'Lo que más me sirvió fue organizar el freezer. Dejé de tener recipientes perdidos y ahora sé qué tengo disponible antes de cocinar.'
}, {
  name: 'Sofía C.',
  place: 'Buenos Aires',
  quote: 'Con el sistema de cocina por tandas aprovecho mucho mejor mi tiempo. En una sesión dejo preparadas varias cosas para los días siguientes.'
}, {
  name: 'Valeria R.',
  place: 'Mendoza',
  quote: 'La lista de compras me ayudó muchísimo. Ahora miro primero lo que ya tengo y compro en función de lo que realmente necesito.'
}];
